// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-card {
  background-color: rgba(var(--white));
  box-sizing: border-box;
}
.news-card__header {
  padding: 3rem 6.875rem 0;
}
@media (max-width: 768px) {
  .news-card__header {
    padding: 1.75rem 1rem 1.25rem;
    height: 2.5rem;
  }
}
.news-card__content {
  padding: 0 6.875rem 3rem;
}
@media (max-width: 768px) {
  .news-card__content {
    padding: 0;
  }
}
.news-card__title {
  font-size: 2rem;
  line-height: 1.3;
  font-weight: 500;
  color: rgba(var(--grey-800));
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .news-card__title {
    font-family: var(--merriweather);
    font-size: 1.25rem;
    line-height: 1.4;
    padding: 0 1rem;
    margin-bottom: 0;
  }
}
.news-card__titles {
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  .news-card__titles {
    flex-direction: column-reverse;
    gap: 0.5rem;
    margin-bottom: 2rem;
  }
}
.news-card__subtitle {
  font-family: var(--merriweather);
  font-size: 0.875rem;
  line-height: 1.57;
  font-weight: 400;
  color: rgba(var(--grey-600));
  margin-bottom: 2.5rem;
}
@media (max-width: 768px) {
  .news-card__subtitle {
    font-family: var(--raleway);
    margin-bottom: 0;
    padding: 0 1rem;
  }
}
.news-card__description {
  font-size: 1.25rem;
  line-height: 1.4;
  font-weight: 400;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .news-card__description {
    font-size: 1rem;
    line-height: 1.625;
    padding: 0 1rem;
    margin-bottom: 2rem;
  }
}
.news-card__description p:first-child {
  margin-top: 0;
}
.news-card__description p:last-child {
  margin-bottom: 0;
}
.news-card__another {
  padding: 0 1rem;
}
.news-card__another-title {
  font-family: var(--merriweather);
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 400;
  color: rgba(var(--grey-800));
  margin-bottom: 1rem;
}
.news-card__another-items {
  display: flex;
  gap: 1rem;
}
.news-card__another-items-card {
  flex: 1 1;
  padding: 0.5rem;
}
.news-card__another-items-card .card__img {
  height: calc((100vw - 2rem - 1rem - 2rem) / 2 / 1.1475);
}
.news-card__photo {
  margin-bottom: 2.5rem;
}
.news-card__photo-wrapper-img {
  position: relative;
  display: flex;
  justify-content: center;
}
.news-card__photo-wrapper-arrow-left {
  position: absolute;
  transform: rotate(180deg);
  left: 0;
  transform: translate(0, -50%) rotate(180deg);
  top: 50%;
  cursor: pointer !important;
}
.news-card__photo-wrapper-arrow-right {
  position: absolute;
  right: 0;
  transform: translate(0, -50%);
  top: 50%;
  cursor: pointer !important;
}
.news-card__photo-img {
  height: calc((100vw - 13.75rem) / 1.77);
  max-width: calc(100vw - 13.75rem);
  border-radius: 0.75rem;
  object-fit: cover;
  display: block;
}
.news-card__photo-carousel {
  margin-top: 1.5rem;
  position: relative;
  overflow: hidden;
  max-width: calc(100vw - 13.75rem);
}
.news-card__photo-carousel-scroll {
  display: flex;
  gap: 1rem;
  overflow: auto;
}
.news-card__photo-carousel-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.news-card__photo-carousel-img {
  width: 130px;
  height: 130px;
  border-radius: 0.5rem;
  object-fit: cover;
  display: block;
  cursor: pointer;
  outline-offset: -3px;
  box-sizing: border-box;
  flex-shrink: 0;
}
.news-card__photo-carousel-img_active {
  outline: 3px solid rgba(var(--grey-400));
}
.news-card__photo-carousel-arrow {
  position: absolute;
  top: 3.5px;
  bottom: 3.5px;
  z-index: 2;
  background-color: rgba(var(--grey-100));
  width: 2.5rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  animation: 0.3s show ease;
}
.news-card__photo-carousel-arrow.-prev {
  box-shadow: 4px 0 4px 0 rgba(34, 37, 45, 0.15);
  left: -1px;
}
.news-card__photo-carousel-arrow.-next {
  box-shadow: -4px 0 4px 0 rgba(34, 37, 45, 0.15);
  right: -1px;
}
.news-card__photo-carousel-arrow-bg {
  width: 4px;
  background-color: transparent;
  position: absolute;
  top: 3.5px;
  bottom: 3.5px;
  animation: 0.3s show ease;
}
.news-card__photo-carousel-arrow-bg.-prev {
  left: -1px;
}
.news-card__photo-carousel-arrow-bg.-next {
  right: -1px;
}
.news-card__photo-carousel-arrow-bg::after {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  right: 0;
  width: 0.25rem;
  background-color: rgba(var(--white));
}
.news-card .swiper-slide {
  aspect-ratio: 1/1;
}
@media (max-width: 768px) {
  .news-card .swiper-slide {
    height: calc((100vw - 2rem) / 1.525);
  }
}
.news-card-mobile__img {
  width: calc(100vw - 2rem);
  height: calc((100vw - 2rem) / 1.525);
  object-fit: cover;
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;
}
.news-card-mobile__scroll {
  position: relative;
  margin: 1.5rem 1rem;
  height: 0.25rem;
  background-color: rgba(var(--grey-100));
}
.news-card-mobile__scroll-item {
  position: absolute;
  height: 0.25rem;
  transition: transform 500ms ease-in-out;
  background-color: rgba(var(--grey-400));
}
.news-card-mobile__slider {
  height: calc((100vw - 2rem) / 1.525);
  position: relative;
}
.news-card__video {
  display: flex;
  justify-content: center;
}
@media (max-width: 768px) {
  .news-card__video {
    width: calc(100vw - 2rem);
    height: calc((100vw - 2rem) / 1.525);
    border-radius: 0.75rem;
    overflow: hidden;
    margin-bottom: 1.5rem;
  }
  .news-card__video::after {
    content: "";
    background: transparent;
    width: 180px;
    height: 120px;
    min-height: 1px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
}
.news-card .news-card-mobile__slider-button {
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
  z-index: 2;
  transition: opacity 300ms ease-in-out;
  right: -5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/NewsCard/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,sBAAA;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,6BAAA;IACA,cAAA;EAEJ;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,UAAA;EAEJ;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;AACJ;AACI;EAPF;IAQI,gCAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,sBAAA;AACJ;AACI;EAJF;IAKI,8BAAA;IACA,WAAA;IACA,mBAAA;EAEJ;AACF;AACE;EACE,gCAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;AACJ;AACI;EARF;IASI,2BAAA;IACA,gBAAA;IACA,eAAA;EAEJ;AACF;AACE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AACJ;AACI;EANF;IAOI,eAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EAEJ;AACF;AACM;EACE,aAAA;AACR;AACM;EACE,gBAAA;AACR;AAIE;EACE,eAAA;AAFJ;AAKE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;AAHJ;AAME;EACE,aAAA;EACA,SAAA;AAJJ;AAOE;EACE,SAAA;EACA,eAAA;AALJ;AAOI;EACE,uDAAA;AALN;AASE;EACE,qBAAA;AAPJ;AAUE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AARJ;AAWE;EACE,kBAAA;EACA,yBAAA;EACA,OAAA;EAEA,4CAAA;EACA,QAAA;EACA,0BAAA;AATJ;AAYE;EACE,kBAAA;EACA,QAAA;EAEA,6BAAA;EACA,QAAA;EACA,0BAAA;AAVJ;AAaE;EACE,uCAAA;EACA,iCAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;AAXJ;AAcE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;AAZJ;AAcI;EACE,aAAA;EACA,SAAA;EACA,cAAA;AAZN;AAcM;EACE,QAAA;EACA,SAAA;AAZR;AAiBE;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;AAfJ;AAiBI;EACE,wCAAA;AAfN;AAmBE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;EACA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAjBJ;AAmBI;EACE,8CAAA;EACA,UAAA;AAjBN;AAoBI;EACE,+CAAA;EACA,WAAA;AAlBN;AAqBI;EACE,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;AAnBN;AAqBM;EACE,UAAA;AAnBR;AAsBM;EACE,WAAA;AApBR;AAuBM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,oCAAA;AArBR;AA0BE;EACE,iBAAA;AAxBJ;AA0BI;EAHF;IAII,oCAAA;EAvBJ;AACF;AA0BE;EACE,yBAAA;EACA,oCAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;AAxBJ;AA2BE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;AAzBJ;AA2BI;EACE,kBAAA;EACA,eAAA;EACA,uCAAA;EACA,uCAAA;AAzBN;AA6BE;EACE,oCAAA;EACA,kBAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,uBAAA;AA5BJ;AA8BI;EAJF;IAKI,yBAAA;IACA,oCAAA;IACA,sBAAA;IACA,gBAAA;IACA,qBAAA;EA3BJ;EA6BI;IACE,WAAA;IACA,uBAAA;IACA,YAAA;IACA,aAAA;IACA,eAAA;IACA,kBAAA;IACA,QAAA;IACA,QAAA;IACA,6BAAA;EA3BN;AACF;AA+BE;EACE,kBAAA;EAEA,6BAAA;EACA,QAAA;EACA,UAAA;EACA,qCAAA;EACA,WAAA;AA7BJ","sourcesContent":[".news-card {\n  background-color: rgba(var(--white));\n  box-sizing: border-box;\n\n  &__header {\n    padding: 3rem 6.875rem 0;\n\n    @media (max-width: 768px) {\n      padding: 1.75rem 1rem 1.25rem;\n      height: 2.5rem;\n    }\n  }\n\n  &__content {\n    padding: 0 6.875rem 3rem;\n\n    @media (max-width: 768px) {\n      padding: 0;\n    }\n  }\n\n  &__title {\n    font-size: 2rem;\n    line-height: 1.3;\n    font-weight: 500;\n    color: rgba(var(--grey-800));\n    margin-bottom: 0.5rem;\n\n    @media (max-width: 768px) {\n      font-family: var(--merriweather);\n      font-size: 1.25rem;\n      line-height: 1.4;\n      padding: 0 1rem;\n      margin-bottom: 0;\n    }\n  }\n\n  &__titles {\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 768px) {\n      flex-direction: column-reverse;\n      gap: 0.5rem;\n      margin-bottom: 2rem;\n    }\n  }\n\n  &__subtitle {\n    font-family: var(--merriweather);\n    font-size: 0.875rem;\n    line-height: 1.57;\n    font-weight: 400;\n    color: rgba(var(--grey-600));\n    margin-bottom: 2.5rem;\n\n    @media (max-width: 768px) {\n      font-family: var(--raleway);\n      margin-bottom: 0;\n      padding: 0 1rem;\n    }\n  }\n\n  &__description {\n    font-size: 1.25rem;\n    line-height: 1.4;\n    font-weight: 400;\n    color: rgba(var(--grey-800));\n\n    @media (max-width: 768px) {\n      font-size: 1rem;\n      line-height: 1.625;\n      padding: 0 1rem;\n      margin-bottom: 2rem;\n    }\n\n    p {\n      &:first-child {\n        margin-top: 0;\n      }\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &__another {\n    padding: 0 1rem;\n  }\n\n  &__another-title {\n    font-family: var(--merriweather);\n    font-size: 1rem;\n    line-height: 1.5;\n    font-weight: 400;\n    color: rgba(var(--grey-800));\n    margin-bottom: 1rem;\n  }\n\n  &__another-items {\n    display: flex;\n    gap: 1rem;\n  }\n\n  &__another-items-card {\n    flex: 1;\n    padding: 0.5rem;\n\n    .card__img {\n      height: calc((100vw - 2rem - 1rem - 2rem) / 2 / 1.1475);\n    }\n  }\n\n  &__photo {\n    margin-bottom: 2.5rem;\n  }\n\n  &__photo-wrapper-img {\n    position: relative;\n    display: flex;\n    justify-content: center;\n  }\n\n  &__photo-wrapper-arrow-left {\n    position: absolute;\n    transform: rotate(180deg);\n    left: 0;\n    -webkit-transform: translate(0, -50%) rotate(180deg);\n    transform: translate(0, -50%) rotate(180deg);\n    top: 50%;\n    cursor: pointer !important;\n  }\n\n  &__photo-wrapper-arrow-right {\n    position: absolute;\n    right: 0;\n    -webkit-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    top: 50%;\n    cursor: pointer !important;\n  }\n\n  &__photo-img {\n    height: calc(calc(100vw - 13.75rem) / 1.77);\n    max-width: calc(100vw - 13.75rem);\n    border-radius: 0.75rem;\n    object-fit: cover;\n    display: block;\n  }\n\n  &__photo-carousel {\n    margin-top: 1.5rem;\n    position: relative;\n    overflow: hidden;\n    max-width: calc(calc(100vw - 13.75rem));\n\n    &-scroll {\n      display: flex;\n      gap: 1rem;\n      overflow: auto;\n\n      &::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n      }\n    }\n  }\n\n  &__photo-carousel-img {\n    width: 130px;\n    height: 130px;\n    border-radius: 0.5rem;\n    object-fit: cover;\n    display: block;\n    cursor: pointer;\n    outline-offset: -3px;\n    box-sizing: border-box;\n    flex-shrink: 0;\n\n    &_active {\n      outline: 3px solid rgba(var(--grey-400));\n    }\n  }\n\n  &__photo-carousel-arrow {\n    position: absolute;\n    top: 3.5px;\n    bottom: 3.5px;\n    z-index: 2;\n    background-color: rgba(var(--grey-100));\n    width: 2.5rem;\n    border-radius: 0.25rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    animation: 0.3s show ease;\n\n    &.-prev {\n      box-shadow: 4px 0 4px 0 rgba(34, 37, 45, 0.15);\n      left: -1px;\n    }\n\n    &.-next {\n      box-shadow: -4px 0 4px 0 rgba(34, 37, 45, 0.15);\n      right: -1px;\n    }\n\n    &-bg {\n      width: 4px;\n      background-color: transparent;\n      position: absolute;\n      top: 3.5px;\n      bottom: 3.5px;\n      animation: 0.3s show ease;\n\n      &.-prev {\n        left: -1px;\n      }\n\n      &.-next {\n        right: -1px;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        z-index: 1;\n        top: 0;\n        bottom: 0;\n        right: 0;\n        width: 0.25rem;\n        background-color: rgba(var(--white));\n      }\n    }\n  }\n\n  .swiper-slide {\n    aspect-ratio: 1 / 1;\n\n    @media (max-width: 768px) {\n      height: calc((100vw - 2rem) / 1.525);\n    }\n  }\n\n  &-mobile__img {\n    width: calc(100vw - 2rem);\n    height: calc((100vw - 2rem) / 1.525);\n    object-fit: cover;\n    border-radius: 0.75rem;\n    margin-bottom: 1.5rem;\n  }\n\n  &-mobile__scroll {\n    position: relative;\n    margin: 1.5rem 1rem;\n    height: 0.25rem;\n    background-color: rgba(var(--grey-100));\n\n    &-item {\n      position: absolute;\n      height: 0.25rem;\n      transition: transform 500ms ease-in-out;\n      background-color: rgba(var(--grey-400));\n    }\n  }\n\n  &-mobile__slider {\n    height: calc((100vw - 2rem) / 1.525);\n    position: relative;\n  }\n\n  &__video {\n    display: flex;\n    justify-content: center;\n\n    @media (max-width: 768px) {\n      width: calc(100vw - 2rem);\n      height: calc((100vw - 2rem) / 1.525);\n      border-radius: 0.75rem;\n      overflow: hidden;\n      margin-bottom: 1.5rem;\n\n      &::after {\n        content: '';\n        background: transparent;\n        width: 180px;\n        height: 120px;\n        min-height: 1px;\n        position: absolute;\n        right: 0;\n        top: 50%;\n        transform: translate(0, -50%);\n      }\n    }\n  }\n\n  .news-card-mobile__slider-button {\n    position: absolute;\n    -webkit-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    top: 50%;\n    z-index: 2;\n    transition: opacity 300ms ease-in-out;\n    right: -5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
